import { ENV_ENUM } from '../lib/sdk/sdk.typings';
function getUA() {
  return typeof navigator !== 'undefined' ? navigator.userAgent : '';
}
function getENV() {
  var ua = getUA(),
    inYach = /Yach/i.test(ua),
    inIOS = /iPhone|iPad|iPod|iOS/i.test(ua) && inYach,
    inAndroid = /Android/i.test(ua) && inYach,
    inPC = /YachPc/i.test(ua),
    inIpad = /iPad/i.test(ua) && inYach,
    inIPhone = /iPhone/i.test(ua) && inYach,
    isTest = /Yachtest/.test(ua) && inYach;
  // platform
  var platform = ENV_ENUM.notInYach;
  if (inIOS) {
    platform = ENV_ENUM.ios;
  }
  if (inAndroid) {
    platform = ENV_ENUM.android;
  }
  if (inPC) {
    platform = ENV_ENUM.pc;
  }
  // version
  var versionArr = ua.match(/Yach\/[a-zA-Z0-9.-]+/) || [];
  var version = (versionArr[0] || '').split('/')[1] || '';
  // language
  var language = typeof navigator !== 'undefined' ? navigator.language : '*';
  return {
    platform: platform,
    platformV2: {
      inYach: inYach,
      inIOS: inIOS,
      inAndroid: inAndroid,
      inPC: inPC,
      inIpad: inIpad,
      inIPhone: inIPhone
    },
    version: version,
    language: language,
    env: isTest ? 'test' : 'online'
  };
}
export { getENV };


//////////////////
// WEBPACK FOOTER
// ./node_modules/yach.open.jssdk/es/utils/env.js
// module id = null
// module chunks = 